import { useState, useEffect } from "react";
import "./Navbar.css";

const NAV_ITEMS = [
  { id: "home", label: "Início", href: "#home" },
  { id: "about", label: "Sobre", href: "#about" },
  { id: "services", label: "Serviços", href: "#services" },
  { id: "clients", label: "Clientes", href: "#clients" },
  { id: "manufacturers", label: "Fabricantes", href: "#manufacturers" },
  { id: "contact", label: "Contato", href: "#contact" },
];

function Navbar() {
  const [activeLink, setActiveLink] = useState("home");
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 32);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const sectionRefs = NAV_ITEMS.map((item) => ({
      id: item.id,
      element: document.querySelector(item.href),
    }));

    const handleScrollSpy = () => {
      const scrollPosition = window.scrollY + 140;
      let currentSection = NAV_ITEMS[0].id;

      sectionRefs.forEach(({ id, element }) => {
        if (!element) return;
        const { offsetTop, offsetHeight } = element;
        if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
          currentSection = id;
        }
      });

      setActiveLink((prev) => (prev === currentSection ? prev : currentSection));
    };

    handleScrollSpy();
    window.addEventListener("scroll", handleScrollSpy);
    return () => window.removeEventListener("scroll", handleScrollSpy);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  const handleNavClick = (id) => {
    setActiveLink(id);
    setIsMenuOpen(false);
  };

  return (
    <header className={`navbar ${isScrolled ? "navbar--scrolled" : ""}`}>
      <div className="navbar__container">
        <a href="#home" className="navbar__brand" aria-label="The Union Technology">
          <img src="/logo-the-union.png" alt="Logo The Union Technology" />
        </a>

        <nav className="navbar__menu" aria-label="Navegação principal">
          {NAV_ITEMS.map(({ id, label, href }) => (
            <a
              key={id}
              href={href}
              className={`navbar__link ${activeLink === id ? "is-active" : ""}`}
              onClick={() => handleNavClick(id)}
            >
              {label}
            </a>
          ))}
        </nav>

        <a href="#contact" className="navbar__cta primary-button">
          Fale com um especialista
        </a>

        <button
          className={`navbar__toggle ${isMenuOpen ? "is-active" : ""}`}
          onClick={toggleMenu}
          aria-label="Alternar menu"
          aria-expanded={isMenuOpen}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <div className={`navbar__drawer ${isMenuOpen ? "is-open" : ""}`}>
        <nav className="navbar__drawer-menu" aria-label="Menu móvel">
          {NAV_ITEMS.map(({ id, label, href }) => (
            <a
              key={id}
              href={href}
              className={`navbar__drawer-link ${activeLink === id ? "is-active" : ""}`}
              onClick={() => handleNavClick(id)}
            >
              {label}
            </a>
          ))}
        </nav>
        <a
          href="#contact"
          className="navbar__drawer-cta primary-button"
          onClick={() => setIsMenuOpen(false)}
        >
          Solicitar contato
        </a>
      </div>
    </header>
  );
}

export default Navbar;
